"use client";

import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { Link } from "@/components/common/Link";
import { User } from "lucide-react";
import { useState } from "react";
const castMembers = [{
  id: 1,
  name: "Nikita Thompson",
  role: "Lead Actress",
  bio: "Nikita brings over a decade of classical training to this groundbreaking production. Her powerful presence and emotional depth have captivated audiences across the country.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_4f0zvagl.png",
  profileUrl: "#"
}, {
  id: 9,
  name: "Allison Rolle",
  role: "Supporting Actress",
  bio: "Known for her transformative approach to staff development and fearless mentorship. Allison's dedication to her craft brings unforgettable moments to the stage.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_cjkmfzc7.png",
  profileUrl: "#"
}, {
  id: 14,
  name: "John Darville",
  role: "Supporting Actor",
  bio: "John's theatrical versatility and commanding vocal presence resonates with every performance. His dedication to character development and collaborative spirit make him an essential member of the ensemble.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_zfwsj1pd.png",
  profileUrl: "#"
}, {
  id: 8,
  name: "Ayanna Cartwright",
  role: "Supporting Actress",
  bio: "A recording artist and psalmist known for her contributions to global ad campaigns. Ayanna's leadership as a former principal inspires her current work in remediation.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_z723mn8a.png",
  profileUrl: "#"
}, {
  id: 7,
  name: "Candace Bostwick",
  role: "Supporting Actress",
  bio: "Candace's expressive range and technical skill have made her a standout in contemporary theater. She transforms each character with authenticity and grace.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_9j04ru3s.png",
  profileUrl: "#"
}, {
  id: 2,
  name: "Stacy Campbell Marshall",
  role: "Supporting Actress",
  bio: "A seasoned entrepreneur and communications expert, Stacy brings a commanding professional perspective. Her unique talent for relationship building inspires every scene she inhabits.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_d1fhbxyx.png",
  profileUrl: "#"
}, {
  id: 4,
  name: "Ashley Knowles",
  role: "Supporting Actor",
  bio: "Ashley is a prominent Bahamian conductor and educator dedicated to choral music. He fosters community through vocal excellence, nurturing young voices while leading premier national musical ensembles.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_ikj8asyc.png",
  profileUrl: "#"
}, {
  id: 11,
  name: "Antonio Knowles",
  role: "Supporting Actor",
  bio: "Antonio's background in vocal performance creates a unique artistic voice. He seamlessly blends leadership and emotion to bring community music to life.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_o0rf5ajx.png",
  profileUrl: "#"
}, {
  id: 3,
  name: "Cherrylee Pinder",
  role: "Supporting Actress",
  bio: "Cherry's background in musical theater and physical performance creates a unique artistic voice. She seamlessly blends movement and emotion taking stories to another level.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_7oaudydq.png",
  profileUrl: "#"
}, {
  id: 5,
  name: "Dion Cunningham",
  role: "Supporting Actor",
  bio: "Dion is a Bahamian concert pianist and educator with a Doctor of Musical Arts. He uses his international performance career to inspire others through artistic passion.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_1oezv20d.png",
  profileUrl: "#"
}, {
  id: 6,
  name: "Kelpurnia \"Cleo\" Spence",
  role: "Supporting Actress",
  bio: "Trained in theater with extensive hours conducted. Kelpurnia brings a seasoned perspective having served multiple choir director roles. Her attention to detail and precision are invaluable for production.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_ivkx0009.png",
  profileUrl: "#"
}, {
  id: 10,
  name: "Frank Reid",
  role: "Supporting Actor",
  bio: "A versatile performer known for his commanding stage presence and nuanced baritone work. Frank's interpretation of diverse musical roles has earned critical acclaim nationwide.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_i7qn543l.png",
  profileUrl: "#"
}, {
  id: 12,
  name: "Simmone Bowe",
  role: "Supporting Actress",
  bio: "Simmone's expertise in contemporary movement and spatial awareness brings a unique dimension to the ensemble. Her collaborative approach enhances the physical storytelling of every scene.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_eb7vw15f.png",
  profileUrl: "#"
}, {
  id: 13,
  name: "Nicolette Archer",
  role: "Supporting Actress",
  bio: "Nicolette's training in vocal performance and dramatic interpretation creates powerful moments on stage. Her ability to convey emotion through both voice and movement enriches the entire production.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_y6qlqeis.png",
  profileUrl: "#"
}, {
  id: 20,
  name: "Makeba Bain",
  role: "Supporting Actress",
  bio: "Makeba Bain is an educator with over twenty‑eight years of experience. She holds a degree in Music Education with a specialty in Vocal Performance. Her passion has afforded her opportunities to perform on local and overseas stages.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_a9v6pz52.png",
  profileUrl: "#"
}, {
  id: 15,
  name: "Dwain Wallace",
  role: "Supporting Actor",
  bio: "Trained in various choirs including the Aeolians and Bel Canto, Dwain brings a multicultural perspective and plethora of experience. His vocal precision elevates the atmosphere.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_qbd7fd4n.png",
  profileUrl: "#"
}, {
  id: 16,
  name: "Chigozie Ijeoma",
  role: "Supporting Actor",
  bio: "A seasoned CFO and theater president, Chigozie brings a commanding professional perspective. His natural charisma and talent are paramount.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_zk8d1f1x.png",
  profileUrl: "#"
}, {
  id: 17,
  name: "Paulette Higgs",
  role: "Supporting Actress",
  bio: "Vocally coached by the late Lee Callander and also a student off the arts in commercial theatre for many years in Jamaica. She is currently a member of the Highgrove singers.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_2y2x3sb7.png",
  profileUrl: "#"
}, {
  id: 18,
  name: "Landy Laroda",
  role: "Supporting Actor",
  bio: "A seasoned poet known as Lyrical Lan, Landy brings a unique metaphorical mastery. His award-winning talent elevates every form of song and art.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_2bjlsykj.png",
  profileUrl: "#"
}, {
  id: 19,
  name: "Allan Butler",
  role: "Supporting Actor",
  bio: "Allan's background in economic leadership and vocal performance creates a unique professional voice. He seamlessly blends global experiences and choral precision to deliver a world-class repertoire.",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_tgpli8sq.png",
  profileUrl: "#"
}];
const crewMembers = [{
  id: 14,
  name: "Philip Gray",
  role: "Executive Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_fnxrmwrz.png",
  profileUrl: "#"
}, {
  id: 15,
  name: "Dion Cunningham",
  role: "Music Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_1oezv20d.png",
  profileUrl: "#"
}, {
  id: 16,
  name: "Robert Bain",
  role: "Choreography Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_ehwu71v4.png",
  profileUrl: "#"
}, {
  id: 17,
  name: "Miquelle Swain",
  role: "Acting Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_e0worfyb.jpg",
  profileUrl: "#"
}, {
  id: 18,
  name: "Edison Sumner ",
  role: "Chorus Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_uu6izior.png",
  profileUrl: "#"
}, {
  id: 19,
  name: "Nikita Thompson",
  role: "Lead Character Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_jmya4owa.png",
  profileUrl: "#"
}, {
  id: 20,
  name: "Melanie Roach",
  role: "Engineering & Logistics Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_9lahe5xv.png",
  profileUrl: "#"
}, {
  id: 21,
  name: "Patrice Gray Wallace",
  role: "Administrative Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_ybi20quy.png",
  profileUrl: "#"
}, {
  id: 22,
  name: "Annika Bain",
  role: "Volunteer Director",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_tpx6340l.png",
  profileUrl: "#"
}, {
  id: 23,
  name: "Lorraine & Swithun Burrows",
  role: "Intercessions Directors",
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1503120/img/image_6faffdcl.png",
  profileUrl: "#"
}];
export default function CastCrew() {
  const [imageErrors, setImageErrors] = useState<Record<number, boolean>>({});
  const handleImageError = (id: number, name: string, imagePath: string) => {
    console.error(`Failed to load image for ${name} (ID: ${id}): ${imagePath}`);
    setImageErrors(prev => ({
      ...prev,
      [id]: true
    }));
  };
  const renderMemberImage = (member: {
    id: number;
    name: string;
    role: string;
    image: string;
  }, hasError: boolean) => {
    if (hasError) {
      return <div className="size-full flex items-center justify-center bg-gradient-to-br from-primary/10 via-secondary/15 to-accent/10 border border-border/50">
          <User className="size-20 text-primary" strokeWidth={1.5} />
        </div>;
    }
    return <img src={member.image} alt={`${member.name} - ${member.role}`} loading="lazy" onError={() => handleImageError(member.id, member.name, member.image)} onLoad={() => console.log(`Successfully loaded image for ${member.name}: ${member.image}`)} className="size-full object-cover transition-transform duration-[var(--duration-slow)] ease-[var(--ease-smooth)] group-hover:scale-105" />;
  };
  return <section id="cast-crew" className="bg-background py-16 px-4 sm:px-6 lg:px-8">
      <div className="mx-auto max-w-7xl">
        <div className="transition-all duration-[var(--duration-slow)] ease-[var(--ease-smooth)]">
          <div className="mb-12 text-center">
            <h2 className="font-display text-4xl font-bold text-foreground mb-3">
              Cast &amp; Crew
            </h2>
            <p className="text-muted-foreground text-lg max-w-2xl mx-auto">
              Meet the talented individuals who bring The Mass to life through
              their artistry and dedication.
            </p>
          </div>

          <div className="mb-16">
            <h3 className="font-display text-2xl font-semibold text-foreground mb-6">
              Cast
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {castMembers.map((member, i) => <Card key={member.id} data-index={i} className="group overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-medium border border-border">
                  <div className="aspect-[3/4] overflow-hidden bg-muted">
                    {renderMemberImage(member, imageErrors[member.id] || false)}
                  </div>
                  <CardContent className="space-y-3 pt-4">
                    <div>
                      <h4 className="font-display text-xl font-semibold text-foreground">
                        {member.name}
                      </h4>
                      <p className="text-muted-foreground text-sm mt-1">
                        {member.role}
                      </p>
                    </div>
                    <p className="text-muted-foreground text-sm leading-relaxed">
                      {member.bio}
                    </p>
                  </CardContent>
                </Card>)}
            </div>
          </div>

          <div>
            <h3 className="font-display text-2xl font-semibold text-foreground mb-6">
              Crew
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
              {crewMembers.map((member, i) => <Card key={member.id} data-index={i} className="group overflow-hidden transition-all duration-[var(--duration-medium)] ease-[var(--ease-out-back)] hover:-translate-y-2 hover:shadow-medium border border-border">
                  <div className="aspect-[3/4] overflow-hidden bg-muted">
                    {renderMemberImage(member, imageErrors[member.id] || false)}
                  </div>
                  <CardContent className="space-y-3 pt-4">
                    <div>
                      <h4 className="font-display text-xl font-semibold text-foreground">
                        {member.name}
                      </h4>
                      <p className="text-muted-foreground text-sm mt-1">
                        {member.role}
                      </p>
                    </div>
                  </CardContent>
                </Card>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}